import { render, staticRenderFns } from "./PurchaseTrademarkContent.vue?vue&type=template&id=f9639342&scoped=true"
import script from "./PurchaseTrademarkContent.vue?vue&type=script&lang=js"
export * from "./PurchaseTrademarkContent.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTrademarkContent.vue?vue&type=style&index=0&id=f9639342&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9639342",
  null
  
)

export default component.exports